import React, { useState } from "react";

// Feed Filter Dropdown Component
const FeedFilterDropdown = ({ activeTab, setActiveTab }) => {
  const [isOpen, setIsOpen] = useState(false);

  const filterOptions = [
    "Feed",
    "Post",
    "Saved",
    "Suggest",
    "Shared",
    "Archive",
  ];

  const handleSelect = (option) => {
    // Map dropdown options to parent component tab names
    const tabMap = {
      "Feed": "feed",
      "Post": "post",
      "Saved": "saved",
      "Suggest": "suggested",
      "Shared": "shared",
      "Archive": "archive",
    };
    
    setActiveTab(tabMap[option]);
    setIsOpen(false);
  };

  return (
    <div className="feed-filter-dropdown-wrapper" style={{alignSelf: "left", marginLeft: 0}}>
      <button
        className="feed-filter-dropdown-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="feed-filter-label">
          {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}
        </span>
        <span className="feed-filter-arrow">▼</span>
      </button>

      {isOpen && (
        <div className="feed-filter-dropdown-menu" style={{marginLeft: 10}}>
          {filterOptions.map((option) => (
            <button
              key={option}
              className={`feed-filter-option ${
                activeTab === option.toLowerCase() ? "active" : ""
              }`}
              onClick={() => handleSelect(option)}
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FeedFilterDropdown;
